import { StepType } from '../types'
import ChatHeaderMenuStep from './ChatHeaderMenu'
import ChatHeaderStep from './ChatHeader'
import ChatInputStep from './ChatInput'
import ChatSuggestionsStep from './ChatSuggestions'
import FinishStep from './Finish'
import VoiceButtonStep from './VoiceButton'

export const GROUPS = ['Getting Started', 'Features']

const STEPS: StepType[] = [
  {
    step: 'chat_header',
    group: GROUPS[0],
    config: ChatHeaderStep,
    page: 'any',
  },
  {
    step: 'chat_header_menu',
    group: GROUPS[0],
    config: ChatHeaderMenuStep,
    page: 'any',
  },
  {
    step: 'chat_input',
    group: GROUPS[0],
    config: ChatInputStep,
    page: 'any',
  },
  {
    step: 'voice_button',
    group: GROUPS[1],
    config: VoiceButtonStep,
    page: 'any',
  },
  {
    step: 'chat_suggestions',
    group: GROUPS[1],
    config: ChatSuggestionsStep,
    page: 'any',
  },
  {
    step: 'finish',
    config: FinishStep,
    page: 'any',
  },
]

export const ADA_CHAT_TOUR_STEPS = STEPS
